import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { get_user_addresses } from '../../redux/actions/location';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import CreateAddress from './createAddress';
import EditAddress from './editAddress';
const UserAddresses = ({
    addresses,
    get_user_addresses,
    petition_addresses
}) => {

    useEffect(() => {
        get_user_addresses();
    }, [get_user_addresses]);

    useEffect(() => {
        if (!petition_addresses) {  // Si no está haciendo la petición de compras
            get_user_addresses();  // Vuelve a cargar las compras
        }
    }, [petition_addresses, get_user_addresses]);

    const getStateColor = (state) => {
        switch (state) {
            case 0:
                return 'bg-gray-500 text-white';
            case 1:
                return 'bg-green-500 text-white';
            default:
                return 'bg-gray-500 text-white';
        }
    };

    return (
        <div className="max-w-6xl mx-xl-auto mt-12 mx-4 p-4 bg-white rounded-xl border shadow-sm">
        
            <h2 className="text-2xl font-bold mb-4 text-ecoprimary1">Tus direcciones</h2>
            <CreateAddress
                updateList={get_user_addresses}
            />
            {petition_addresses ? (
                <div className="flex justify-center">
                    <div className="animate-spin border-4 border-t-4 border-orange-500 border-solid rounded-full w-10 h-10"></div>
                </div>
            ) : addresses.length === 0 ? (
                <div className='bg-blue-100 rounded-3 p-2 w-fit'>
                    <p className="text-ecoprimary1 mb-0">No tienes datos registrados</p>
                </div>
            ) : (
                <>
                    <div className="overflow-x-auto w-full">
                        <table className="min-w-full text-sm rounded-lg overflow-hidden divide-y divide-gray-200">
                            <thead className="bg-blue-200 text-ecoprimary1">
                                <tr>
                                    <th className="px-3 py-2 text-left min-w-[50px]">ID</th>
                                    <th className="px-2 py-2 text-left min-w-[120px]">Direccíon</th>
                                    <th className="px-2 py-2 text-left min-w-[120px]">Descripción</th>
                                    <th className="px-2 py-2 text-left min-w-[120px]">Teléfono</th>
                                    <th className="px-2 py-2 text-left w-[50px]">Predeterminado</th>
                                    <th className="px-2 py-2 text-left w-[50px]">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {addresses.map((address, index) => (
                                    <tr key={index} className="bg-blue-50">
                                        <td className="px-3 py-2">{address.id}</td>
                                        <td className="px-2 py-2">{address.address}</td>
                                        <td className="px-2 py-2">{address.description}</td>
                                        <td className="px-2 py-2">{address.phone}</td>
                                        <td className="px-2 py-2">
                                            {
                                                address.is_check == 1 &&
                                                <span className={`px-2 py-1 rounded-full text-xs font-medium uppercase ${getStateColor(address.is_check)}`}>
                                                    <FontAwesomeIcon icon={faCheck} size="lg" />
                                                </span>
                                            }

                                        </td>
                                        <td className="px-2 py-2">
                                            <EditAddress
                                                currentAddress={address}
                                                updateList={get_user_addresses}
                                            />
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </div>
    );
};

const mapStateToProps = state => ({
    addresses: state.Location.addresses,
    petition_addresses: state.Location.petition_addresses
});

export default connect(mapStateToProps, { get_user_addresses })(UserAddresses);
